import React, { useState } from "react";
import { InputForm, SubmitButton, Error } from "components";
import { CloudUploadIcon } from "assets";

interface ThumbnailFormProps {
  loading: boolean;
  header: string;
  thumbnailUrl?: string | null;
  errorMessage?: string;
  handleThumbnailFileChange?: (file: File) => void;
  handleSubmit?: React.MouseEventHandler<HTMLButtonElement>;
  initalThumbnai?: string | null;
}

export const ThumbnailForm: React.FC<ThumbnailFormProps> = ({
  loading,
  header,
  thumbnailUrl,
  errorMessage,
  handleThumbnailFileChange,
  handleSubmit,
  initalThumbnai,
}) => {
  const [thumbnailFile, setThumbnailFile] = useState<File | null>(null);
  const [thumbnailPreviewUrl, setThumbnailPreviewUrl] = useState<string | null>(
    null
  );

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      setThumbnailFile(file);
      setThumbnailPreviewUrl(URL.createObjectURL(file));
      if (handleThumbnailFileChange) handleThumbnailFileChange(file);
    }
  };

  return (
    <form>
      <h2 className="text-xl font-bold my-3">{header}</h2>

      {/* Thumbnail Upload Section */}
      {thumbnailPreviewUrl ? (
        <div className="mb-4">
          <p className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Thumbnail Preview:
          </p>
          <img
            src={initalThumbnai ? initalThumbnai : thumbnailPreviewUrl}
            alt="Thumbnail Preview"
            className="w-full max-h-96 rounded-md border border-gray-300 object-contain"
          />
        </div>
      ) : (
        <div
          id="Upload Thumbnail"
          className="flex items-center justify-center w-full mb-4"
        >
          <label
            htmlFor="dropzone-thumbnail"
            onDrop={(e) => {
              e.preventDefault();
              e.stopPropagation();
              const file = e.dataTransfer.files?.[0];
              if (file) {
                setThumbnailFile(file);
                setThumbnailPreviewUrl(URL.createObjectURL(file));
                if (handleThumbnailFileChange) handleThumbnailFileChange(file);
              }
            }}
            onDragOver={(e) => e.preventDefault()}
            className="relative flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100"
          >
            {thumbnailUrl ? (
              <>
                <img
                  src={initalThumbnai ? initalThumbnai : thumbnailUrl}
                  alt="Current Poster"
                  className="absolute inset-0 w-full h-full object-cover rounded-lg opacity-70"
                />
                <div className="z-10 flex flex-col items-center justify-center">
                  <CloudUploadIcon />
                  <p className="mb-2 text-sm text-white">
                    <span className="font-semibold">Click to upload</span> or
                    drag and drop
                  </p>
                  <p className="text-xs text-white">JPG, PNG, WebP formats</p>
                </div>
              </>
            ) : (
              <div className="flex flex-col items-center justify-center pt-5 pb-6">
                <CloudUploadIcon />
                <p className="mb-2 text-sm text-gray-500">
                  <span className="font-semibold">Click to upload</span> or drag
                  and drop
                </p>
                <p className="text-xs text-gray-500">JPG, PNG, WebP formats</p>
              </div>
            )}
            <input
              id="dropzone-thumbnail"
              type="file"
              accept="image/*"
              className="hidden"
              onChange={handleFileChange}
            />
            {errorMessage && <Error>{errorMessage}</Error>}
          </label>
        </div>
      )}

      {/* Submit Button */}
      <SubmitButton loading={loading} onClick={handleSubmit} />
    </form>
  );
};
